import { fetchArticle } from '@elevio/kb-kit/lib/api/article';
import { Categories } from '@elevio/kb-kit/lib/components';
import { useCategories, useLanguages } from '@elevio/kb-kit/lib/hooks';
import { useEffect, useState } from 'react';
import ArticleList from '../components/ArticleList';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HomeArticles from '../components/HomeArticles';
import { MainSection } from '../components/layouts/Main';
import PageLayout from '../components/layouts/Page';
import Breadcrumb from '../components/PageBreadcrumbs';
import { fetchAgencyFlags } from '../requests/agency-flags';
import { homeArticleIds, loginRequestsIconUrl, submitRequestIconUrl, viewAllRequestsIconUrl, } from '../utils/constants';
import { crmToken, privateSubmissionUrl } from '../utils/privateSubmissionUrl';
const AGENCY_ID = 191;
export const getHeader = () => {
    return (<Header hideSearch breadcrumbs={<div className="breadcrumbs-header-wrapper">
          <Breadcrumb className="breadcrumbs-header"/>
        </div>}>
      <div className="header-container"/>
    </Header>);
};
const HomePage = () => {
    useCategories();
    const { selectedLanguage } = useLanguages();
    const [articles, setArticles] = useState([]);
    const [showViewAllRequests, setShowViewAllRequests] = useState(false);
    useEffect(() => {
        const fetchArticles = async () => {
            const response = await Promise.all(homeArticleIds.map((id) => fetchArticle(id, selectedLanguage.id)));
            setArticles(response);
        };
        fetchArticles();
    }, [selectedLanguage.id]);
    useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const openPrivateSubmission = (path) => {
        const url = privateSubmissionUrl(path);
        if (!url) {
            return;
        }
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('public-map');
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        <section className="button-container button-container--three" aria-label="Quick actions">
          <div className="button-wrapper">
            <a href={`https://agency.comcate.com/private-submission/create?crm_token=${crmToken}`} className="cta-request" target="_blank" rel="noopener noreferrer">
              <img src={submitRequestIconUrl} alt="submit request icon" aria-hidden="true"/>
              Submit a Request
            </a>
          </div>
          <div className="button-wrapper">
            <a href={`https://agency.comcate.com/private-submission/listing?crm_token=${crmToken}`} className="cta-request" target="_blank" rel="noopener noreferrer">
              <img src={loginRequestsIconUrl} alt="my requests icon" aria-hidden="true"/>
              View My Requests
            </a>
          </div>
          {showViewAllRequests ? (<div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleViewAllRequests}>
                <img src={viewAllRequestsIconUrl} alt="view all requests icon" aria-hidden="true"/>
                View All Requests
              </button>
            </div>) : null}
        </section>
        <section className="article-container">
          <div className="view-requests-section">
            <HomeArticles articles={articles}/>
          </div>
          <div className="view-requests-section">
            <Categories.Loop limit={1}>
              <ArticleList />
            </Categories.Loop>
          </div>
        </section>
      </MainSection>
    </PageLayout>);
};
export default HomePage;
